import React from 'react'

import Text from 'components/common/Text'
import Tooltip2 from 'components/common/Tooltip2.0'

import { Block } from './styles'

import { allColors } from '../../../utils/colors'

const Blocks = props => {
    const dataLen = props.data?.length || 0
    return props.data?.map((participant, index) => {
        if (!participant) return null
        if (participant.user_id === props.localUserId) return null
        const { activity, user_id, name } = participant
        const [firstName] = name.split(' ')
        const colorIndex = index % allColors.length
        const color = allColors[colorIndex].bg
        const tooltip = (
            <Text level="2" color={color}>
                {firstName} • {parseInt(activity)}%
            </Text>
        )
        return (
            <Tooltip2 key={user_id} placement="top" content={tooltip}>
                <Block activity={activity} color={color} dataLen={dataLen} />
            </Tooltip2>
        )
    })
}

export default Blocks
